export default __webpack_public_path__ + "static/media/V2-CARROUSEL_4.44b63d90.png";